


/**
 * uses some code from Jacky See's Stupid Fixed Header 1.0.3
 * jQuery plugin to work with ftl table macro template
 *   http://www.opensource.org/licenses/mit-license.php
*/




(function($){
	$.fn.tableWidget = function(o){
		var defaults = {};
		return this.each(function(){
			var self = $(this);
			$.tableWidget.syncTableWidth(self);
			$.tableWidget.primeSearch(self);

			// attach the on change event to the inner table
			$(this).find(".tableWidgetInner table").change($.tableWidget.onChange);


			// deal with resize
			$(window).resize(function(){
				$.tableWidget.syncTableWidth(self);
			});

			// attach events for search
			var runSearch = function(e){
				$.tableWidget.runSearch(self);
				return false;
			}
			var handleReturnKeyInSearch = function(e){
				if(e.keyCode == 13){
					$.tableWidget.runSearch(self);
					return false;
				}
			}
			var resetSearch = function(e){
				self.parents().find('input.tableWidgetSearch').clearFields();
				self.parents().find('select.tableWidgetSearch').val("");
				$.tableWidget.runSearch(self);
			}

			self.parents().find('a.tableWidgetSearch.searchReset').click(resetSearch);
			self.parents().find('button.tableWidgetSearch').click(runSearch);
			self.parents().find('select.tableWidgetSearch').change(runSearch);
			self.parents().find('input.tableWidgetSearch').keypress(handleReturnKeyInSearch);
			self.parents().find('input.tableWidgetSearch.dateRange').datepick(
				{
					rangeSelect: true,
					onClose: runSearch,
					showOn: 'focus',
					alignment:'bottomRight',
					dateFormat: 'mm/dd/yyyy',
					showTrigger: ""
				}
			);
			// handle sort features
			self.find('table.tableWidget.header thead tr:last > th').each(function(i, val){
				if($(this).hasClass('sort')){
					$(this).wrapInner("<a class='tableSort ht1-Link ht1-TableSort' href=''></a>").children('a').click(function(){
						$.tableWidget.sortRows(self, i+1);
						return false;
					});
				}
			});
		});
	}

	$.tableWidget = {
		/**
		 * Table Clean Up cleans up the table if there are any elements that need to be reset after/before a change
		 * they should be added here
		 * ppeterson 4/26/10
		 *
		 */
		cleanUp: function(widget){
			var table = null;
			if( widget.tagName == "DIV"){
				table = $(widget).find(".tableWidgetInner table");
			}else{
				table = widget;
			}

			// remove any open quick views
			$(table).find("tr.quickView").remove();
			// hide the quick view actions
			$(table).find("tr td .rowActions").css("visibility", "hidden");
			// remove any active classes
			$(table).find("tr.active").removeClass("active");
			// remove any matched result classes
			$(table).find("tr.matchedResult").removeClass("matchedResult");
		},
		onChange: function(){
		/**
		 * Table On Change function
		 * attched to the table's on change event
		 * ppeterson 4/26/10
		 *
		 */

			$(this).find("tbody tr.odd").removeClass("odd");

			$(this).find("tbody tr:nth-child(odd)").addClass("odd");
		},
		calcWidth: function(th){
			var w = $(th).width();
			var paddingLeft = $.tableWidget.getComputedStyleInPx(th,'paddingLeft');
			var paddingRight = $.tableWidget.getComputedStyleInPx(th,'paddingRight');
			var borderWidth = $.tableWidget.getComputedStyleInPx(th,'borderRightWidth');
			w = w+borderWidth;
			return w;
		},
		getComputedStyleInPx: function(elem,style){
			var computedStyle = (typeof elem.currentStyle != 'undefined')
				?elem.currentStyle
				:document.defaultView.getComputedStyle(elem, null);
			var val = computedStyle[style];
			val = val? parseInt(val.replace("px","")):0;
			return (!val || val == 'NaN')?0:val;
		},
		getScrollBarWidth: function(tableWidget) { //calculate or get from global the scroll bar width
			if(!$.tableWidget.scrollBarWidth){
				if(tableWidget.find('div.tableWidgetInner').css('height') == '100%') {
					$.tableWidget.scrollBarWidth = 0;
				} else {
					var inner = $(document.createElement('p')).css({width:'100%',height:'100%'});
					var outer = $(document.createElement('div'))
						.css({
							position:'absolute',
							top: '0px',
							left: '0px',
							visibility: 'hidden',
							width: '200px',
							height: '150px',
							overflow: 'hidden'
						})
						.append(inner)
						.appendTo(document.body);

					var w1 = inner[0].offsetWidth;
					outer[0].style.overflow = 'scroll';
					var w2 = inner[0].offsetWidth;
					if (w1 == w2) w2 = outer[0].clientWidth;
					document.body.removeChild (outer[0]);
					$.tableWidget.scrollBarWidth = (w1 - w2);
				}
			}
			return $.tableWidget.scrollBarWidth;
		},
		syncTableWidth: function(tableWidget) { // sync the width of the associated tables and their columns
			$("td.fileName").each(function(){
				var anchor = $(this).find('a');
		    	var fileName = $.trim($(anchor).text());
		    	var length = fileName.length;
		    	if(length > 20){
		    		$(anchor).text(fileName.substr(0,17) + "...");
		    	}
			});

			var scrollBarWidth = this.getScrollBarWidth(tableWidget);
			var calcWidth = this.calcWidth;

			var headTable = tableWidget.find('table.tableWidget.header');
			var headTableThs = tableWidget.find('table.tableWidget.header thead tr:last > th');
			var innerContainer = tableWidget.find('div.tableWidgetInner');
			var bodyTable = tableWidget.find('table.tableWidget.body:visible');
			var footTableTds = tableWidget.find('table.tableWidget.footer tfoot tr:first:not(:has(td[colspan])) > td');

			// fix column width
			var ieVersion = $("#browserVersion").data("ieVersion");
			//TODO: check which versions of IE this actually breaks in
			if(ieVersion < 9){
				innerContainer.css('padding-right', scrollBarWidth);
			}
			bodyTable.find('tbody tr:first > td').each(function(i){
				if(this.colSpan === undefined || this.colSpan == 1) { // don't td with colSpan to calc width
					var width = calcWidth(this);
					if(i == (headTableThs.length - 1)){ width = width + scrollBarWidth; }
					headTableThs.eq(i).css('width', width);
					footTableTds.eq(i).css('width', width);
				}
			});
		},
		primeSearch: function(tableWidget) { // prepare data structures for search
			$(tableWidget).data('searchArr', $(tableWidget).find('input.searchString').attr('value').split('|'));
			$(tableWidget).data('rowArr', $(tableWidget).find('table.tableWidget.body tbody tr:not(.quick_view)').get());

			this.primeDateSearch(tableWidget);
			// autocomplete
			var autoCompleteList = $('input.autoCompleteString').attr('value').split('|');
			$('#searchText').autocomplete(
				{
					source: autoCompleteList,
					matchContains: true
				}
			);
		},
		primeDateSearch: function(tableWidget) { // prepare the date data structure
			var dateIndex = tableWidget.find('table.tableWidget.header thead tr:last > th')
					.index($('table.tableWidget.header thead tr:last > th.filter.date'));
			var dateArr = [];
			$('table.tableWidget.body:visible tbody tr > td:nth-child('+(dateIndex+1)+')').each(function(i, e){
				try{
					dateArr[i] = new Date($(this).text());
				}catch(ex){
					console.log('error parsing date for filter');
					dateArr = [];
					return false;
				}
			});
			$(tableWidget).data('dateArr', dateArr);
		},
		runSearch: function(tableWidget){
			// disable the search fieldset

			$(tableWidget).parents().find('fieldset.tableWidgetSearch :enabled').attr('disabled', true);

			var query = '';
			$(tableWidget).parents().find('.tableWidgetSearch.query:input:visible:not(select), select.tableWidgetSearch.query:input:visible option:selected').each(function(){
				query += " " + $(this).val();
			});
			var dateString = $(tableWidget).parents().find('.tableWidgetSearch.dateRange:input:visible').val();
			var dates = [null, null];
			if(dateString && $.trim(dateString).length > 0){
				dates = $.map(dateString.split(/\s*-\s*/), function(str){
					try{
						return new Date(str);
					}catch(ex){
						return null;
					}
				});
			}
			this.searchTable(tableWidget, query, dates[0], dates[1]);
			// enable the search fieldset again
			$(tableWidget).find('fieldset.tableWidgetSearch :disabled').attr('disabled', false);
		},
		searchTable: function(tableWidget, query, fromDate, toDate) { // filter out rows that do not match the query
			var queryArr = $.trim(query).toUpperCase().split(/\s+/);
			var searchArr = $(tableWidget).data('searchArr');
			var dateArr = $(tableWidget).data('dateArr');
			var rowArr = $(tableWidget).data('rowArr');
			var tbl = $(tableWidget).find(".tableWidgetInner").children("table");
			var dateFunc;
			if(fromDate != null && toDate != null){
				dateFunc = function(i){
					return (dateArr[i] >= fromDate && dateArr[i] <= toDate);
				};
			}else if(fromDate != null){
				dateFunc = function(i){
					return (dateArr[i] == fromDate);
				};
			}else{
				dateFunc = function(){
					return true;
				};
			}

			var hits = $.map(searchArr, function(val, i){
				var match = true;
				$.each(queryArr, function(index, word){
					return (match = ((word.length == 0) || (val.indexOf(word) != -1)));
				});
				match = (match && dateFunc(i));
				return match ? rowArr[i] : null;
			});

			tbl.data("matches", hits);

			$.tf.processResults(tbl);
		},
		sortRows: function(tableWidget, col){
			var indicatorClass = "down";
			var oldSort = $(tableWidget).data('sortCol');
			var oldSortIndicator = $(tableWidget).data('sortIndicator');
			var tbl = $(tableWidget).find(".tableWidgetInner").children("table");
			var sortCol = $(tableWidget).find('table.tableWidget.header thead tr:last > th:nth-child('+(col)+')');
			var elems;

			$.tableWidget.cleanUp(tableWidget);

			if(oldSort == col){ // already sorted, just need to be reversed
				elems = $(tableWidget).find('table.tableWidget.body tbody tr').get();
				indicatorClass = (oldSortIndicator.localeCompare(indicatorClass) == 0) ? "up" : indicatorClass;
				elems.reverse();

			}else{ // not sorted, and will not be reversed
				if(tbl.data("matches") != null){
					elems = tbl.data("matches").slice(0);
				}else{
					elems = $(tableWidget).data('rowArr').slice(0);
				}

				var compFunc, sortFunc;
				if(sortCol.hasClass("date")){
					compFunc = function(a,b) {
						return (Date.parse(a) - Date.parse(b));
					};
				}else if(sortCol.hasClass("numeric")){
					compFunc = function(a,b) {
						return (a - b);
					};
				}else{
					compFunc = function(a,b) {
						return (a.toLocaleUpperCase().localeCompare(b.toLocaleUpperCase()));
					};
				}

				sortFunc = function(a, b) {

					var val1 = $.trim($(a.getElementsByTagName('td')[col - 1]).text());
					var val2 = $.trim($(b.getElementsByTagName('td')[col - 1]).text());
					return compFunc(val1,val2);
				};
				elems.sort(sortFunc);
			}
			// reset any old sort indicator
			$(tableWidget).find('table.tableWidget.header thead tr > th a.tableSort').removeClass("up down");
			// replace elements
			$(tableWidget).find('table.tableWidget.body:visible tbody').prepend(elems);
			// add new sort indicator
			sortCol.find("a.tableSort").addClass(indicatorClass);
			$(tableWidget).data('sortCol', col);
			$(tableWidget).data('sortIndicator', indicatorClass);

			// fire off the on change event
			$(tableWidget).find(".tableWidgetInner table").change();

		}
	}

	$(function(){
    $('.fullColSpan').livequery('.fullColSpan', document,
      function() {
			var tbl = $(this).parents('table');
			var thead = tbl.children('thead');
			var tr = thead.children('tr');
			var span = tr.children().length;
			//alert(colSpan);
			$(this).parent('td').each(function() {
				this.colSpan = span;
			});
		});
	});

})(jQuery);
